export interface Section {
    section_id: number;
    project_tender_part_id: number;
    section_name: string;
    section_no: string;
    after_section_no?: number;
    section_amount: number;
    sub_section_data?: SubSection[];
    section_item_data?: SectionItem[];
}

export interface SectionItem {
    item_id: number;
    section_id: number;
    item_name: string;
    item_no: string;
    after_item_no?: number;
    item_amount_total?: number;
    item_amount_data?: SectionItemAmount | null;
}

export interface SectionItemAmount { }

export interface SubSection {
    sub_section_id: number;
    section_id: number;
    sub_section_name: string;
    sub_section_no: string;
    after_sub_section_no?: number;
    sub_section_amount: number;
    sub_section_item_data?: SubSectionItem[];
}

export interface SubSectionItem {
    item_id: number;
    sub_section_id: number;
    item_name: string;
    item_no: string;
    after_item_no?: number;
    item_amount_total: number;
    item_amount_data?: SubSectionItemAmount[];
}


export interface SubSectionItemAmount {
    item_amount_id: number;
    item_id: number;
    item_name: string;
    item_no: string;
    unit_no: number;
    unit_price: number;
    total: number;
    note: string;
}

export const sections: Section[] = [
    {
        section_id: 1,
        project_tender_part_id: 1,
        section_no: '1',
        section_amount: 0,
        section_name: 'Conditions of Contract / Preliminaries',
        after_section_no: 0,
        sub_section_data: [
            {
                sub_section_id: 1,
                section_id: 1,
                sub_section_name: 'Contract and preliminaries',
                sub_section_no: '1.0',
                after_sub_section_no: 0,
                sub_section_amount: 0,
                sub_section_item_data: [
                    {
                        item_id: 1,
                        sub_section_id: 1,
                        item_name: 'Following review of Appendix "A" and Appendix "B" the Contractor is to insert below his proposed costs in respect of the "Articles of Agreement and C',
                        item_no: '1.0.1',
                        after_item_no: 0,
                        item_amount_total: 0,
                        item_amount_data: [
                            {
                                item_amount_id: 1,
                                item_id: 1,
                                item_name: 'Contractor',
                                item_no: '1.0.1.1',
                                unit_no: 1,
                                unit_price: 50,
                                total: 100,
                                note: ''
                            }
                        ]
                    },
                    {
                        item_id: 2,
                        sub_section_id: 1,
                        item_name: 'Articles and Conditions of Contract (as Appendix A)',
                        item_no: '1.0.2',
                        after_item_no: 1,
                        item_amount_total: 0,
                        item_amount_data: []
                    },
                    {
                        item_id: 3,
                        sub_section_id: 1,
                        item_name: 'extra for Performance Bond',
                        item_no: '1.0.3',
                        after_item_no: 2,
                        item_amount_total: 0,
                        item_amount_data: []
                    },
                    {
                        item_id: 4,
                        sub_section_id: 1,
                        item_name: 'Preliminaries (as Appendix B)',
                        item_no: '1.0.4',
                        after_item_no: 3,
                        item_amount_total: 0,
                        item_amount_data: []
                    },
                    {
                        item_id: 5,
                        sub_section_id: 1,
                        item_name: 'extra for Energy Performance Certificates for all flats',
                        item_no: '1.0.5',
                        after_item_no: 4,
                        item_amount_total: 0,
                        item_amount_data: []
                    },
                    {
                        item_id: 6,
                        sub_section_id: 1,
                        item_name: 'extra for air test',
                        item_no: '1.0.6',
                        after_item_no: 5,
                        item_amount_total: 0,
                        item_amount_data: []
                    }
                ]
            },
            {
                sub_section_id: 2,
                section_id: 1,
                sub_section_name: 'Temporary works',
                sub_section_no: '1.1',
                after_sub_section_no: 1,
                sub_section_amount: 0,
                sub_section_item_data: []
            }
        ],
        section_item_data: []
    },
    {
        section_id: 2,
        project_tender_part_id: 1,
        section_no: '2',
        section_amount: 0,
        section_name: 'Preambles',
        after_section_no: 1,
        sub_section_data: [],
        section_item_data: []
    },
    {
        section_id: 3,
        project_tender_part_id: 1,
        section_no: '3',
        section_amount: 0,
        section_name: 'Substructure and concrete frame',
        after_section_no: 2,
        sub_section_data: [],
        section_item_data: []
    },
    {
        section_id: 4,
        project_tender_part_id: 1,
        section_no: '4',
        section_amount: 0,
        section_name: 'Superstructure work',
        after_section_no: 3,
        sub_section_data: [],
        section_item_data: [
            {
                item_id: 7,
                section_id: 4,
                item_name: 'Sub tractor and superstructure masonry',
                item_no: '4.1.0',
                after_item_no: 0,
                item_amount_total: 0,
                item_amount_data: null
            },
            {
                item_id: 8,
                section_id: 4,
                item_name: 'In forming all external masonry walls to specification',
                item_no: '4.1.1',
                after_item_no: 1,
                item_amount_total: 0,
                item_amount_data: null
            },
            {
                item_id: 9,
                section_id: 4,
                item_name: 'Thermabate insulated cavity closer as manufactured by Kingspan Insulation Ltd, or similar approved; installed in accordance with the manufacturer’s instructions',
                item_no: '4.1.2',
                after_item_no: 2,
                item_amount_total: 0,
                item_amount_data: null
            },
            {
                item_id: 10,
                section_id: 4,
                item_name: 'Additional inline wall for new and existing structure',
                item_no: '4.1.3',
                after_item_no: 3,
                item_amount_total: 0,
                item_amount_data: null
            },
            {
                item_id: 11,
                section_id: 4,
                item_name: 'Fornt elevation decorative work',
                item_no: '4.1.4',
                after_item_no: 4,
                item_amount_total: 0,
                item_amount_data: null
            }
        ]
    },
    {
        section_id: 5,
        project_tender_part_id: 1,
        section_no: '5',
        section_amount: 0,
        section_name: 'Mechanical and electrical work',
        after_section_no: 4,
        sub_section_data: [],
        section_item_data: []
    }
]

export interface Preliminaries {
    priliminiery_id: number;
    project_tender_part_id: number;
    item_name: string;
    ref_number: string;
    after_ref_number?: number;
}

export const preliminaries: Preliminaries[] = [
    {
        priliminiery_id: 1,
        project_tender_part_id: 1,
        ref_number: "1",
        item_name: "Site set up",
        after_ref_number: 0,
    },
    {
        priliminiery_id: 2,
        project_tender_part_id: 1,
        ref_number: "2",
        item_name: "Site accommodation",
        after_ref_number: 1,
    },
    {
        priliminiery_id: 3,
        project_tender_part_id: 1,
        ref_number: "3",
        item_name: "Health & safety",
        after_ref_number: 2,
    },
    {
        priliminiery_id: 4,
        project_tender_part_id: 1,
        ref_number: "4",
        item_name: "Insurence",
        after_ref_number: 3,
    },
    {
        priliminiery_id: 5,
        project_tender_part_id: 1,
        ref_number: "5",
        item_name: "Temp lightening and power setup",
        after_ref_number: 4,
    },
    {
        priliminiery_id: 6,
        project_tender_part_id: 1,
        ref_number: "6",
        item_name: "Management and supervision - 48 week",
        after_ref_number: 5,
    },
    {
        priliminiery_id: 7,
        project_tender_part_id: 1,
        ref_number: "7",
        item_name: "Site labour",
        after_ref_number: 6,
    }
]